import { IOverlay } from '@makyoapp/makyo-sdk/models/AppBuilder'

import { IAppClient } from './app'
import { AppLayer, IAppLayer } from './layer'

export interface IAppOverlay extends IAppLayer {
  settings: IOverlay
}

export class AppOverlay extends AppLayer implements IAppOverlay {
  settings: IOverlay

  constructor(appClient: IAppClient, index: number, overlay: IOverlay) {
    super(appClient, index, overlay, 'overlay')
    this.settings = overlay
  }

  //--------------------------------------------------------------------------------------//
  //                             Overlay Specific Methods                                 //
  //--------------------------------------------------------------------------------------//
}
